import { Attendance, ATTENDANCE_CONFIG, ServiceSettlementType } from '@pflegix/types';
import { MultiSelectOption } from '@pflegix/ui';

export const ATTENDANCES_TO_SETTLEMENT_TYPE_MAPPING: Partial<Record<ServiceSettlementType, MultiSelectOption[]>> = {
  [ServiceSettlementType.PFLEGIX_INTERNAL]: [
    { label: ATTENDANCE_CONFIG[Attendance.NV_347_TEAM_BRIEFING].label, value: Attendance.NV_347_TEAM_BRIEFING },
    { label: ATTENDANCE_CONFIG[Attendance.NV_348_TRAINING].label, value: Attendance.NV_348_TRAINING },
    { label: ATTENDANCE_CONFIG[Attendance.NV_349_OFFICE_CLEAN_UP].label, value: Attendance.NV_349_OFFICE_CLEAN_UP },
    { label: ATTENDANCE_CONFIG[Attendance.NV_350_HR_MEETING].label, value: Attendance.NV_350_HR_MEETING },
  ],
  [ServiceSettlementType.SGB_V_S38_HOME_HELP]: [
    { label: ATTENDANCE_CONFIG[Attendance.NV_343_CONSULTING].label, value: Attendance.NV_343_CONSULTING },
    {
      label: ATTENDANCE_CONFIG[Attendance.NV_351_HOUSEHOLD_ASSISTANCE_SERIES].label,
      value: Attendance.NV_351_HOUSEHOLD_ASSISTANCE_SERIES,
    },
    {
      label: ATTENDANCE_CONFIG[Attendance.NV_352_HOUSEHOLD_ASSISTANCE_RATE].label,
      value: Attendance.NV_352_HOUSEHOLD_ASSISTANCE_RATE,
    },
    {
      label: ATTENDANCE_CONFIG[Attendance.NV_353_HOUSEHOLD_ASSISTANCE_PREGNANCY].label,
      value: Attendance.NV_353_HOUSEHOLD_ASSISTANCE_PREGNANCY,
    },
  ],
  [ServiceSettlementType.SGB_XI_S45B_CARE]: [
    {
      label: ATTENDANCE_CONFIG[Attendance.NV_290_SUPPORT_COORDINATION].label,
      value: Attendance.NV_290_SUPPORT_COORDINATION,
    },
    {
      label: ATTENDANCE_CONFIG[Attendance.NV_343_CONSULTING].label,
      value: Attendance.NV_343_CONSULTING,
    },
    {
      label: ATTENDANCE_CONFIG[Attendance.NV_362_GROUP_OFFER_ALLOWANCE].label,
      value: Attendance.NV_362_GROUP_OFFER_ALLOWANCE,
    },
    {
      label: ATTENDANCE_CONFIG[Attendance.NV_91_ASSISTANCE].label,
      value: Attendance.NV_91_ASSISTANCE,
    },
  ],
  [ServiceSettlementType.SGB_XI_S45C_SCHOOLING]: [
    {
      label: ATTENDANCE_CONFIG[Attendance.NV_255_SCHOOLING_HOME].label,
      value: Attendance.NV_255_SCHOOLING_HOME,
    },
  ],
  [ServiceSettlementType.SGB_XI_S37_PAR3_COUNSELLING_MISSION]: [
    {
      label: ATTENDANCE_CONFIG[Attendance.NV_282_CONSULTATION_VISIT].label,
      value: Attendance.NV_282_CONSULTATION_VISIT,
    },
  ],
};
